export function formatSubmissionAnswers(answers: Record<string, string>): string {
  if (!answers) {
    return ''
  }
  return Object.entries(answers)
    .map(([question, answer]) => {
      return `<h4 style="margin: 0px;">${question}</h4><p style="margin: 0px;">${answer}</p><br>`
    })
    .join('')
}
